import React, { useEffect, useState } from "react";
import { X } from "react-feather";
import styles from "./Editor.module.css";
import BasicInfoBody from "./Sections/BasicInfoBody";
import WorkExpBody from "./Sections/WorkExpBody";
import ProjectBody from "./Sections/ProjectBody";
import EducationBody from "./Sections/EducationBody";
import SkillBody from "./Sections/SkillBody";
import AchievementBody from "./Sections/AchievementBody";
import CourseBody from "./Sections/CourseBody";
import PorBody from "./Sections/PorBody";
import {exampleProject, exampleExperience, exampleEducation, exampleSkill} from "./Sections/Examples";

function Editor(props) {
  const sections = props.sections;

  const [activeSectionKey, setActiveSectionKey] = useState(
    Object.keys(sections)[0]
  );
  const [activeDetailIndex, setActiveDetailIndex] = useState(0);

  const examples = {
    "Projects": exampleProject,
    "Experience": exampleExperience,
    "Education": exampleEducation,
    "Skills": exampleSkill,
  };

  const generateBody = () => {
    switch (sections[activeSectionKey]) {
      case sections.basicInfo:
        return <BasicInfoBody
          information = {props.information} 
          setInformation = {props.setInformation}
          sections = {sections}
        />;
      case sections.workExp:
        return props.information[sections.workExp].details.length ? 
        <WorkExpBody 
          information = {props.information} 
          setInformation = {props.setInformation}
          activeDetailIndex = {activeDetailIndex} 
          sections = {sections}
        /> : null;
      case sections.project:
        return props.information[sections.project].details.length ? 
        <ProjectBody 
          information = {props.information} 
          setInformation = {props.setInformation}
          activeDetailIndex = {activeDetailIndex} 
          sections = {sections}
        /> : null;
      case sections.education:
        return props.information[sections.education].details.length ? 
        <EducationBody 
          information = {props.information} 
          setInformation = {props.setInformation}
          activeDetailIndex = {activeDetailIndex} 
          sections = {sections}
        /> : null;
      case sections.achievement:
        return <AchievementBody
          information = {props.information} 
          setInformation = {props.setInformation}
          sections = {sections}
        />;
      case sections.skill:
        return props.information[sections.skill].details.length ? 
        <SkillBody
          information = {props.information} 
          setInformation = {props.setInformation}
          activeDetailIndex = {activeDetailIndex} 
          sections = {sections}
        /> : null;
      case sections.course:
        return <CourseBody
          information = {props.information} 
          setInformation = {props.setInformation}
          sections = {sections}
        />;
      case sections.por:
        return <PorBody
          information = {props.information} 
          setInformation = {props.setInformation}
          sections = {sections}
        />;
      default:
        return null;
    }
  };

  const handleAddNew = () => {
    const detailLength = props.information[sections[activeSectionKey]].details.length;
    props.setInformation((prev) => ({
      ...prev,
      [sections[activeSectionKey]]: {
        ...prev[sections[activeSectionKey]],
        details: [
          ...prev[sections[activeSectionKey]].details,
          examples[sections[activeSectionKey]]
        ]
      },
    }));
    setActiveDetailIndex(detailLength);
  };

  const handleDeleteDetail = (index) => {
    const details = props.information[sections[activeSectionKey]].details;
    details.splice(index, 1);
    props.setInformation((prev) => ({
      ...prev,
      [sections[activeSectionKey]]: {
        ...prev[sections[activeSectionKey]],
        details: [...details],
      },
    }));
    setActiveDetailIndex((prev) => (prev === index ? prev - 1 : prev));
  };

  useEffect(() => {
    setActiveDetailIndex(0);
  }, [activeSectionKey]);


  return (
    <div className={styles.container}>
      <div className={styles.header}>
        {Object.keys(sections)?.map((key) => (
          <div
            className={`${styles.section} ${
              activeSectionKey === key ? styles.active : ""
            }`}
            key={key}
            onClick={() => setActiveSectionKey(key)}
          >
            {sections[key]}
          </div>
        ))}
      </div>

      <div className={styles.body}>
        <div className={styles.chips}>
          {props.information[sections[activeSectionKey]]?.details?
            props.information[sections[activeSectionKey]]?.details?.map((item, index) => (
                <div
                  className={`${styles.chip} ${
                    activeDetailIndex === index ? styles.active : ""
                  }`}
                  key={item.title + index}
                  onClick={() => setActiveDetailIndex(index)}
                >
                  <p>
                    {sections[activeSectionKey]} {index + 1}
                  </p>
                  <X
                    onClick={(event) => {
                      event.stopPropagation();
                      handleDeleteDetail(index);
                    }}
                  />
                </div>
              ))
            : ""}
          {props.information[sections[activeSectionKey]]?.details &&
            <div className={styles.new} onClick={handleAddNew}>
              +New
            </div>
          }
        </div>

        {generateBody()}
      </div>
    </div>
  );
}

export default Editor;
